import autoBind from "auto-bind";
import PropTypes from "prop-types";
import React from "react";

import config from "../config";

class MediaMonitorAbstract extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      messages: PropTypes.array,
      is_last_page: PropTypes.bool
    }),
    mediaMonitor: PropTypes.shape({
      messages: PropTypes.array,
      is_last_page: PropTypes.bool
    })
  };

  constructor(props) {
    super(props);

    autoBind.react(this);
  }

  onButtonClick() {
    const {
      data,
      mediaMonitor,
      ticker,
      market,
      getMoreMediaMonitorEntries,
      loadMoreMediaMonitor
    } = this.props;

    if (typeof loadMoreMediaMonitor === "function") {
      loadMoreMediaMonitor();
      return;
    }

    const monitor = mediaMonitor || data || { messages: [] };
    const start = (monitor.messages || []).length;

    if (typeof getMoreMediaMonitorEntries === "function") {
      getMoreMediaMonitorEntries({
        start,
        count: config.recommendationsToFetch,
        ticker,
        market
      });
    }
  }
}

export default MediaMonitorAbstract;
